import React from 'react';
import PropTypes from 'prop-types';

// components
import { Link } from 'src/components/Inputs';

const propTypes = {
  id: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      icon: PropTypes.string | PropTypes.shape(),
      alt: PropTypes.string,
      submenu: PropTypes.arrayOf(
        PropTypes.shape({
          href: PropTypes.string,
          title: PropTypes.string,
        }),
      ),
    }).isRequired,
  ).isRequired,
};

const SideNav = ({ id, items }) => {
  return (
    <ul id={id} className='menu sidenav-menu vertical' data-sidenav-toggle>
      {items.map((sideNavItem, i) => {
        return (
          <li key={`sideNavItem-${i}`}>
            <Link href={sideNavItem.href}>
              <a className='sidenav-menu-item has-subnav' {...sideNavItem}>
                <span className='sidebar-legal-icon' alt={sideNavItem.alt}>
                  {sideNavItem.icon}
                </span>
                {sideNavItem.title}
              </a>
            </Link>
            <ul
              className='menu vertical sidenav-submenu'
              data-magellan
              data-offset='50'
              data-threshold='100'
            >
              {sideNavItem?.submenu?.map((subMenuItem, i) => {
                return (
                  <li key={`subMenuItem-${i}`}>
                    <Link href={subMenuItem.href}>
                      <a {...subMenuItem}>{subMenuItem.title}</a>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </li>
        );
      })}
    </ul>
  );
};
SideNav.propTypes = propTypes;
export default SideNav;
